/* GOLDENAGE money, one currency per sentence.
 *
 * The bug this fixes (David's screenshot, 2026-10-02, the JP market): the offer rungs are typed in
 * the shop currency (USD: 90 / 130 / 240) and snippets/ga-drop.liquid turned them into cents and
 * printed them with a money filter. A money filter does not convert, so a shopper in yen read
 * "¥90 / ¥130 / ¥240" against a bag of ¥7,300 and the bar told them every reward was already
 * theirs. Shopify converts an automatic discount's minimum for the shopper, so the bar has to
 * convert too, or it promises a reward the checkout refuses.
 *
 * The method is PR Studio's (prstudio-rebuild/assets/pr-offer.js): Liquid cannot convert, so the
 * rungs travel as shop currency anchors in data-ga-usd, and this converts them with
 * Shopify.currency.rate, the same rate the checkout uses, rounded UP to a clean step so the bar
 * never asks for less than checkout does. Until it has run, anything that depends on the
 * conversion is invisible ([data-ga-fx="0"] without .is-ready), so a wrong figure is never on
 * screen.
 *
 *   window.gaMoney.fx()                true when the shopper is not in the shop currency
 *   window.gaMoney.convert(c, 'up')    shop currency cents -> the shopper's cents
 *   window.gaMoney.format(cents)       the shopper's cents -> "¥13,500"
 *   window.gaMoney.apply(root)         fills every [data-ga-usd] under root and marks it ready
 */
(function () {
  if (window.gaMoney) return;

  function shopCurrency() {
    var el = document.documentElement.getAttribute('data-ga-shop-currency');
    return (el || window.gaShopCurrency || 'USD').toUpperCase();
  }
  function cur() { return (window.Shopify && window.Shopify.currency) || {}; }
  function iso() { return String(cur().active || shopCurrency()).toUpperCase(); }
  function rate() { var r = parseFloat(cur().rate); return r > 0 ? r : 1; }
  function fx() { return iso() !== shopCurrency(); }

  /* a clean step for the currency: 1 where a unit means something, 10 or 100 for the weak ones
     (JPY, CZK, KRW), so a rung reads 13,500 and not 13,482 */
  function step() {
    var r = rate();
    return r >= 100 ? 100 : r >= 10 ? 10 : 1;
  }

  /* shop currency cents in, the shopper's cents out. 'up' for a threshold (never promise a rung
     the checkout would not grant), 'down' for the value of a reward. */
  function convert(cents, dir) {
    var c = Number(cents) || 0;
    if (!fx()) return c;
    var units = (c / 100) * rate();
    var st = step();
    var clean = dir === 'down' ? Math.floor(units / st) * st : Math.ceil(units / st) * st;
    return Math.round(clean * 100);
  }

  var fmtCache = {};
  function formatter() {
    var key = iso();
    if (!fmtCache[key]) {
      try {
        fmtCache[key] = new Intl.NumberFormat(undefined, { style: 'currency', currency: key });
      } catch (e) {
        fmtCache[key] = null;
      }
    }
    return fmtCache[key];
  }

  function format(cents) {
    var n = (Number(cents) || 0) / 100;
    var f = formatter();
    var out = f ? f.format(n) : n.toFixed(2) + ' ' + iso();
    /* no trailing zeros, the way the server prints them */
    return out.replace(/([.,])00(?=\D*$)/, '');
  }

  /* every amount printed from a shop currency anchor */
  function apply(root) {
    var where = root || document;
    where.querySelectorAll('[data-ga-usd]').forEach(function (el) {
      var usd = parseInt(el.getAttribute('data-ga-usd'), 10);
      if (isNaN(usd)) return;
      var c = convert(usd, el.getAttribute('data-ga-round') || 'up');
      el.setAttribute('data-ga-cents', c);
      el.textContent = format(c);
    });
    where.querySelectorAll('[data-ga-fx="0"]').forEach(function (el) { el.classList.add('is-ready'); });
    if (where !== document && where.getAttribute && where.getAttribute('data-ga-fx') === '0') where.classList.add('is-ready');
  }

  window.gaMoney = {
    shopCurrency: shopCurrency,
    iso: iso,
    rate: rate,
    fx: fx,
    step: step,
    convert: convert,
    format: format,
    apply: apply,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
  else apply();
  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });
})();
